export class OnboardingEmployment {
  sourceOfIncomeId: number;
  sourceOfIncomeDesc: string;
  occupationId: number;
  occupationDesc: string;
  countryId: number;
  countryDesc: string;
  annualIncomeId: number;
  annualIncomeDesc: string;
  taxPayerCertificationCheckbox: boolean;

  constructor() {
    this.sourceOfIncomeId = 0;
    this.sourceOfIncomeDesc = '';
    this.occupationId = 0;
    this.occupationDesc = '';
    this.countryId = 0;
    this.countryDesc = '';
    this.annualIncomeId = 0;
    this.annualIncomeDesc = '';
    this.taxPayerCertificationCheckbox = false;
  }
}
